
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/affiliateProgram",
      function () {
        return require("private-next-pages/article/affiliateProgram.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/affiliateProgram"])
      });
    }
  